import React from "react";
import { Badge } from "flowbite-react";
import { ArticlePublicationBadge } from "@/components/articles/ArticlePublicationBadge";
import {
  formatArticleDate,
  type ArticlePublicationStatus,
} from "@/domains/articles/Article";

export interface ArticleHeroProps {
  category: string;
  title: string;
  publishedAt: string;
  updatedAt: string;
  tags: readonly string[];
  publicationStatus: ArticlePublicationStatus;
  imageUrl?: string;
}

export const ArticleHero: React.FC<ArticleHeroProps> = ({
  category,
  title,
  publishedAt,
  updatedAt,
  tags,
  publicationStatus,
  imageUrl,
}) => {
  return (
    <div className="relative overflow-hidden border-b border-primary-100 bg-background">
      {imageUrl && (
        <>
          <img
            src={imageUrl}
            alt={`${title}のアイキャッチ`}
            width={1200}
            height={800}
            className="absolute inset-0 h-full w-full object-cover object-[center_30%]"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent from-40% to-background" />
        </>
      )}
      <div
        className={`relative mx-auto max-w-6xl px-4 ${
          imageUrl ? "pt-48 pb-8 md:pt-64 md:pb-10" : "py-8 md:py-12"
        }`}
      >
        <div className="mx-auto max-w-3xl text-center">
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-primary-500">
            <span>{category}</span>
            <ArticlePublicationBadge status={publicationStatus} />
          </div>
          <h1 className="heading-wrap mt-2 text-2xl font-bold leading-snug text-primary-700 md:text-3xl">
            {title}
          </h1>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-xs text-primary-500">
            <span>公開日 {formatArticleDate(publishedAt)}</span>
            {updatedAt !== publishedAt && (
              <span>更新日 {formatArticleDate(updatedAt)}</span>
            )}
          </div>
          {tags.length > 0 && (
            <div className="mt-4 flex flex-wrap justify-center gap-1">
              {tags.map((tag) => (
                <Badge key={tag} color="gray" size="xs">
                  {tag}
                </Badge>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
